<template>
    <div class="parking-find-num">
        <div class="msg" v-if="globalLang != 'kz/'">Найдено {{ filterParkingDataBase.filter_items_count }} {{correctWord}}</div>
        <div class="msg" v-if="globalLang == 'kz/'">{{ filterParkingDataBase.filter_items_count }} автотұрақ табылды</div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'parking-find-num',
        components: {
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                correctWord: null,
            }
        },
        computed: mapGetters({
            filterParkingDataBase: 'loadFilterParkingData',
        }),
        methods: {
            correctFindWord() {
                function pluralizeWord(number, word) {
                    const lastDigit = number % 10;
                    if (number == 1) {
                        return word + "о"; // Для чисел, заканчивающихся на 1 или 8
                    } else if (lastDigit >= 2 && lastDigit <= 4) {
                        return word + "а"; // Для чисел, заканчивающихся на 2-4
                    } else {
                        return word + ""; // Для всех остальных чисел
                    }
                }
                const word = 'машиномест';
                this.correctWord = pluralizeWord(this.filterParkingDataBase.filter_items_count, word);
            }
        },
        created () {
            this.correctFindWord();
        },
        mounted() {
            this.$store.watch(
                (state) => state.filterParking_Data.filter_items_count,
                (newValue) => {
                    if (newValue) {
                        this.correctFindWord();
                    }
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/parking-page/parking-find-num.scss';
    @import '@/styles/components/parking-page/respond/parking-find-num-respond.scss';
</style>